import React, { useState, useEffect } from "react";
import Pagination from "react-bootstrap/Pagination";
import Select from 'react-select';

import 'components/common/tables.css';

const AppPagination = (props) => {

    const [pageArray, setPageArray] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const elementsPerPageOptions = [
        { value: 5, label: 5 },
        { value: 10, label: 10 },
        { value: 20, label: 20 }
    ]

    const setTotalPagesFunction = (pageSize) => {
        var totalPages = Math.ceil(parseInt(props.totalRecords) / parseInt(pageSize));
        if (totalPages === 0) {
            setTotalPages(1)
        } else {
            setTotalPages(totalPages)
        }
        return totalPages;
    }

    useEffect(() => {
        setTotalPagesFunction(props.pageSize);
    }, [props.pageSize,setTotalPagesFunction]);

    useEffect(() => {
        var pageArr = [];
        var i = 1;
        if (totalPages === 0) {
            pageArr.push(1);
        } else {
            while (i <= totalPages) {
                pageArr.push(i);
                i++;
            }
        }
        setPageArray(pageArr);
    }, [totalPages]);

    const pageClicked = (page_number) => {
        props.setPaginationObject({ currPage: page_number, endIndex: page_number * props.pageSize, startIndex: (page_number * props.pageSize) - props.pageSize, pageSize: props.pageSize })

    };
    
    useEffect(() => {
        let totalPages = setTotalPagesFunction(props.pageSize)
        if (props.currentPage > totalPages)
            pageClicked(props.currentPage - 1);
    }, [props.totalRecords,props.currentPage,props.pageSize,pageClicked]);

    

   

    const changePageSize = (values) => {
        setTotalPagesFunction(values.value)
        props.setPaginationObject({ pageSize: values.value, currPage: 1, endIndex: values.value, startIndex: 0 })
    }

    return (
        <>
            {props.children}
            <div style={{ marginTop: "15px" }}>
                <Pagination style={{ justifyContent: "center" }}>
                    <Select className="paginationSelect"
                        defaultValue={elementsPerPageOptions.find(elem => elem.value === props.pageSize)}
                        options={elementsPerPageOptions}
                        onChange={(values) => { changePageSize(values) }}
                    />
                    {pageArray.map((ele, ind) => {
                        const toReturn = [];
                        if (ind === 0) {
                            toReturn.push(<Pagination.First key={"firstpage"} onClick={props.currentPage === 1 ? () => { } : () => { pageClicked(1); }} />);
                            toReturn.push(<Pagination.Prev key={"prevpage"} onClick={props.currentPage === 1 ? () => { } : () => { pageClicked(props.currentPage - 1); }} />);
                        }
                        return toReturn;
                    })}
                    <h6 className="pagination-label"> page {props.currentPage} out of {totalPages}</h6>
                    {pageArray.map((ele, ind) => {
                        const toReturn = [];
                        if (ind === pageArray.length - 1) {
                            toReturn.push(<Pagination.Next key={"nextpage"} onClick={props.currentPage === ele ? () => { } : () => { pageClicked(props.currentPage + 1); }} />);
                            toReturn.push(<Pagination.Last key={"lastpage"} onClick={props.currentPage === ele ? () => { } : () => { pageClicked(ele); }} />);
                        }
                        return toReturn;
                    })}
                </Pagination>
            </div>
        </>
    );
}

export default AppPagination;